import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, take } from 'rxjs/operators';
import { APP_CONFIG } from 'src/app/core/services/config.service';

const TRANS_OAUTH_REDIRECT_URI_KEY = 'transOAuthRedirectUri';
const SUPPORTED_LANGUAGES = ['de', 'en', 'fr', 'pl', 'ru', 'es', 'cz', 'tr'];

@Injectable({
  providedIn: 'root',
})
export class TransService {
  private transUrl: string;
  private transId: string;

  constructor(private translate: TranslateService, private router: Router) {
    APP_CONFIG()
      .pipe(
        filter((config) => !!config.transUrl && !!config.transClientId),
        take(1),
      )
      .subscribe((config) => {
        this.transUrl = config.transUrl;
        this.transId = config.transClientId;
      });
  }

  public redirectToLogin(): void {
    APP_CONFIG()
      .pipe(
        filter((config) => !!config.transUrl && !!config.transClientId),
        take(1),
      )
      .subscribe((config) => {
        this.transUrl = config.transUrl;
        this.transId = config.transClientId;
        this.performRedirect();
      });
  }

  public getRedirectUrl(): string {
    return sessionStorage.getItem(TRANS_OAUTH_REDIRECT_URI_KEY) ?? this.buildRedirectUrl();
  }

  public clearStoredRedirectUrl(): void {
    sessionStorage.removeItem(TRANS_OAUTH_REDIRECT_URI_KEY);
  }

  private performRedirect(): void {
    const redirectUri = this.buildRedirectUrl();
    sessionStorage.setItem(TRANS_OAUTH_REDIRECT_URI_KEY, redirectUri);

    const randomNumber = Math.floor(100000000 + Math.random() * 900000000);
    window.location.href =
      `${this.transUrl}oauth2/auth?client_id=` +
      `${this.transId}&response_type=code&scope=offline%20openid&state=${randomNumber}&redirect_uri=` +
      `${redirectUri}&scope=goodloading.companies-api.employees.read.scope`;
  }

  private buildRedirectUrl(): string {
    const lang = this.getLangFromPath() ?? this.translate.currentLang;
    const isMobile = this.router.url.includes('mobile') || window.location.pathname.includes('/mobile/');

    if (isMobile) {
      return `${window.location.origin}/${lang}/mobile/login`;
    }

    return `${window.location.origin}/${lang}/auth/login`;
  }

  private getLangFromPath(): string | null {
    const segment = window.location.pathname.split('/').filter(Boolean)[0];
    return SUPPORTED_LANGUAGES.includes(segment) ? segment : null;
  }
}
